import React, { useEffect, useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import AllProductList from "./AllProductList";
import Labels from "./Labels";
import Cards from "./Cards";
import RJSLabels from "./RJSLabels";
import Masks from "./Masks";
import Tabs from "../../../components/elements/Tabs";
import { useNavigate } from "react-router-dom";

const List = () => {
  // setTitle("HJL");
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const [taballData, setTabAllData] = useState("");

  useEffect(() => {
    const storedTab = localStorage.getItem("activeTabSlug");
    if (storedTab) {
      setTabAllData(storedTab);
    } else {
      setTabAllData("all-products");
    }
  }, []);

  useEffect(() => {
    if (taballData !== "") {
      localStorage.setItem("activeTabSlug", taballData);
    }
  }, [taballData]);

  const tabData = [
    {
      _id: 1,
      name: "All Products",
      slug: "all-products",
      component: <AllProductList />,
    },
    {
      _id: 2,
      name: "Labels",
      slug: "labels",
      component: <Labels taballData={taballData} />,
    },
    {
      _id: 3,
      name: "RJS Labels",
      slug: "rjs-labels",
      component: <RJSLabels taballData={taballData} />,
    },
    {
      _id: 4,
      name: "Cards",
      slug: "cards",
      component: <Cards taballData={taballData} />,
    },
    {
      _id: 5,
      name: "Masks",
      slug: "masks",
      component: <Masks taballData={taballData} />,
    },
  ];

  useEffect(() => {
    const activeTabIndex = tabData.findIndex((tab) => tab.slug === taballData);
    if (activeTabIndex !== -1) {
      setActiveTab(tabData[activeTabIndex]._id);
    }
  }, [taballData, tabData]);

  return (
    <>
      <div className="w-full py-4 md:px-6 px-0">
        <div className="font-bold text-3xl m-1 text-secondary"></div>
        <div className="relative w-full">
          <Tabs
            tabs={tabData}
            selectedTabId={activeTab}
            onTab={(tab) => {
              setActiveTab(tab?._id);
              setTabAllData(tab?.slug);
              navigate("/admin/product-list");
            }}
          />
        </div>
      </div>
    </>
  );
};

export default List;
